/* eslint-disable tailwindcss/no-custom-classname */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { DeliveryExpress } from '@one-thd/sui-icons';
import { ON_DEMAND, SAME_DAY } from '../../helpers/constants';
import { capitalizeFirstLetter } from '../../helpers/utils';
import { FSDBMMessage } from './FSDBMMessage';

const getDeliveryCharge = (option) => {
  if (option?.totalCharge) {
    return <span className="sui-text">${Number(option?.totalCharge).toFixed(2)}</span>;
  }
  return option?.totalCharge === 0 ? <span className="sui-text-success">Free</span> : <span />;
};

const formatOnDemandLabel = (timeline) => {
  const hourMatch = timeline?.match(/^(\d+)\s+hours?$/i);
  if (hourMatch) {
    return `${hourMatch[1]}-Hour Delivery`;
  }
  return `${timeline} Delivery`;
};

const getTimelineText = (option) => {
  const type = option?.type;
  if (type === ON_DEMAND) {
    return formatOnDemandLabel(option?.timeline);
  }
  if (type === SAME_DAY) {
    const timeline = option?.timeline;
    return timeline?.toLowerCase() === 'today'
      ? `${capitalizeFirstLetter(timeline.toLowerCase())}*`
      : `${timeline}*`;
  }
  return option?.timeline;
};

const PriorityOption = ({ option, enableFSDBM, bodfsLatestDelivery, hideBorder = false }) => {
  const applyPriorityClass = () => {
    if (!enableFSDBM) return "sui-pb-5";
    if (hideBorder) return "sui-pb-4";
    return "sui-border-t-1 sui-border-primary sui-border-solid sui-py-4";
  };
  return (
    <div>
      <div className={applyPriorityClass()}>
        <Typography variant="body-lg" height="normal">
          <div className="sui-grid sui-grid-cols-12">
            <div className="sui-col-span-10">
              {option?.type === ON_DEMAND ? (
                <span className="sui-inline-flex sui-items-center sui-gap-2">
                  <span className="sui-inline-flex sui-shrink-0" data-testid="delivery-express-priority-option-icon">
                    <DeliveryExpress size="small" />
                  </span>
                  <span className="sui-font-bold">{getTimelineText(option)}</span>
                </span>
              ) : (
                <>
                  {'Get it '}
                  <span className="sui-font-bold">{getTimelineText(option)}</span>
                  {enableFSDBM && option?.type === SAME_DAY && <span>{' by '}{bodfsLatestDelivery}</span>}
                </>
              )}
            </div>
            <div className="sui-col-span-2 sui-text-end sui-font-bold">
              {getDeliveryCharge(option)}
            </div>
          </div>
        </Typography>
      </div>
    </div>
  );
};

export const PriorityDeliveryOptions = ({
  priorityDeliveryOptions = [],
  enableFSDBM = false,
  fsdbmThreshold,
  bodfsLatestDelivery
}) => {
  const onDemand = priorityDeliveryOptions?.find((option) => option?.type === ON_DEMAND);
  const sameDay = priorityDeliveryOptions?.find((option) => option?.type === SAME_DAY);
  const isSameDayFree = sameDay?.totalCharge === 0;
  const showSameDayOption = !enableFSDBM || !isSameDayFree || !fsdbmThreshold;

  return (
    <div data-testid="priority-delivery-options">
      {onDemand && <PriorityOption option={onDemand} enableFSDBM={enableFSDBM} />}
      {sameDay && (
        <div>
          {enableFSDBM && fsdbmThreshold && (
            <div className="sui-border-t-1 sui-border-primary sui-border-solid sui-pt-4">
              <FSDBMMessage threshold={fsdbmThreshold} isFree={isSameDayFree} />
            </div>
          )}
          {showSameDayOption && (
            <PriorityOption
              option={sameDay}
              enableFSDBM={enableFSDBM}
              bodfsLatestDelivery={bodfsLatestDelivery}
              hideBorder={enableFSDBM}
            />
          )}
        </div>
      )}
    </div>
  );
};
